<template>
    <div class="remarks" v-loading="_gHlp.isLoading('fetch_case_remark')">
        <b-card no-body>
            <b-card-header class="p-3 d-flex justify-content-between align-items-center">
                <h3 class="mb-0">Remarks</h3>
								<div class="d-flex align-items-center text-primary cursor-pointer"
									@click="$refs.drawer_remark_list.show()">
									<p class="text-primary">View All</p>
								</div>
            </b-card-header>
            <div class="m-3">
								<div v-if="!_gHlp.isEmpty(lastRemarks)">
									<div class="d-flex flex-column align-items-start mb-2" v-for="(item,index) in lastRemarks" :key="'clect-'+index">
										<div v-html="item.content"></div>
										<small>{{ item.created_at || '-' | dateFormatString }}</small>
									</div>
								</div>
								<p class="text-muted" v-else>This user don’t have any remark yet</p>

                <div class="d-flex justify-content-center align-items-center text-primary mt-3 cursor-pointer" @click="$refs.modal_add_remark.show()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="16" height="20" viewBox="0 0 448 512"><path fill="currentColor" d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h144v144c0 17.7 14.3 32 32 32s32-14.3 32-32V288h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg>
                    Add Remark
                </div>
            </div>
        </b-card>
				<ModalAddRemark ref="modal_add_remark" />
				<DrawerRemarkList ref="drawer_remark_list" />
    </div>
</template>

<script>
import { Card, Button } from 'element-ui'
import { mapState } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore'
import ModalAddRemark from '@/views/CreditLoanCase/Modals/ModalAddRemark';
import DrawerRemarkList from '@/views/CreditLoanCase/Drawers/DrawerRemarkList';

export default {
	components: {
		DrawerRemarkList,
		ModalAddRemark,
		[Card.name]: Card,
		[Button.name]: Button,
	},
	data() {
		return {
		}
	},
	computed: {
		...mapState(useLoanCaseStore, ['activeRemarks']),
		lastRemarks(){
			return (!_gHlp.isEmpty(this.activeRemarks) && this.activeRemarks.length > 3) ? this.activeRemarks.slice(0,2) : this.activeRemarks;
		}
	},
	methods: {}
}
</script>